import { RemoteProductPlansService } from '@prodcard/core-web-app'
import { httpClient } from './remote'

const productPlansService = new RemoteProductPlansService(httpClient)

export { productPlansService }
